import { LabeledSelectControl, LabeledSelectProps } from '@gorila-shared-ui/components';
import { Select } from 'baseui/select';

export function LabeledSelect({
  value,
  onChange,
  options,
  label,
  searchable = false,
  multi = false,
  disabled = false,
  labelKey,
  valueKey,
  maxWidth,
  placeholder,
  selectMaxWidth,
  required = false,
  clearable = false,
  loading = false,
}: Readonly<LabeledSelectProps>) {
  return (
    <LabeledSelectControl
      label={label}
      disabled={disabled}
      maxWidth={maxWidth}
      required={required}
    >
      <Select
        closeOnSelect
        openOnClick
        clearable={clearable}
        onChange={onChange}
        options={options}
        searchable={searchable}
        multi={multi}
        size={'compact'}
        value={value}
        labelKey={labelKey}
        valueKey={valueKey}
        placeholder={placeholder}
        isLoading={loading}
        overrides={{
          Root: {
            style: {
              maxWidth: selectMaxWidth ? `${selectMaxWidth}px` : undefined,
            },
          },
        }}
      />
    </LabeledSelectControl>
  );
}
